const LEGACY_SHIFT_MIN_MS = 50 * 60 * 1000;
const LEGACY_SHIFT_MAX_MS = 70 * 60 * 1000;
const FUTURE_CLOCK_TOLERANCE_MS = 5 * 60 * 1000;
const ONE_HOUR_MS = 60 * 60 * 1000;

export function parseUtcTimestamp(value) {
  if (value instanceof Date) return new Date(value.getTime());
  if (typeof value !== 'string' || !value.trim()) return null;

  const source = value.trim();
  const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(source);
  const parsed = new Date(hasOffset ? source : `${source.replace(' ', 'T')}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/**
 * Return the real order instant in UTC.
 *
 * Older production API responses expose `date_creation` with a synthetic
 * +61-minute adjustment. Prefer the earlier `order_time` when that signature is
 * present. Some POS devices with pre-September-2026 Morocco timezone data can
 * also send an otherwise valid timestamp exactly one hour in the future; a
 * kitchen order cannot legitimately be future-dated, so correct that boundary.
 */
export function getCanonicalOrderDate(order, nowMs = Date.now()) {
  const orderTime = parseUtcTimestamp(order?.order_time);
  const dateCreation = parseUtcTimestamp(order?.date_creation);

  let canonical = orderTime || dateCreation;
  if (orderTime && dateCreation) {
    const difference = dateCreation.getTime() - orderTime.getTime();
    if (difference >= LEGACY_SHIFT_MIN_MS && difference <= LEGACY_SHIFT_MAX_MS) {
      canonical = orderTime;
    }
  }

  if (!canonical) return null;

  const futureBy = canonical.getTime() - nowMs;
  if (futureBy > FUTURE_CLOCK_TOLERANCE_MS && futureBy <= LEGACY_SHIFT_MAX_MS) {
    return new Date(canonical.getTime() - ONE_HOUR_MS);
  }

  return canonical;
}

export function getOrderAgeMinutes(order, nowMs = Date.now()) {
  const canonical = getCanonicalOrderDate(order, nowMs);
  if (!canonical) return null;

  const minutes = Math.floor((nowMs - canonical.getTime()) / 60000);
  return minutes >= 0 && minutes <= 1440 ? minutes : null;
}
